export default "__VITE_ASSET__BOEmkWbP__"